import type { ProjectDetail } from '@/stores/project/types';
import type { RemixUpgradeModalOpenOptions } from '@/stores/remixUpgradeModal/types';
import { useRemixUpgradeModalStore } from '@/stores/remixUpgradeModal';
import { useUserStore } from '@/stores/user';
import { REMIX_MAX_CREDITS } from './const';

/**
 * 判断是否应该使用 RemixUpgradeModal
 * 两个条件全部满足才走新弹窗：
 * 1. 当前项目由 remix 创建
 * 2. 当前是free用户
 */
export function shouldUseRemixModal(project: ProjectDetail | null): boolean {
  if (project?.websiteSource !== 'remix') {
    return false;
  }

  return useUserStore.getState().isFreeUser;
}

export function getRemixInsufficientCreditsOpenOptions(): RemixUpgradeModalOpenOptions {
  return {
    defaultTab: 'credits',
    visibleTabs: ['credits', 'subscription'],
  };
}

export function getRemixUpgradeButtonOpenOptions(params: {
  userPoints: number | undefined;
  totalCreditsPurchased: number;
}): RemixUpgradeModalOpenOptions {
  const hasUserCredits = typeof params.userPoints === 'number' && params.userPoints > 0;
  const hasPurchasedAllCredits = params.totalCreditsPurchased >= REMIX_MAX_CREDITS;

  return {
    defaultTab: 'subscription',
    visibleTabs: hasUserCredits || hasPurchasedAllCredits
      ? ['subscription']
      : ['credits', 'subscription'],
  };
}

export function openRemixInsufficientCreditsModal() {
  useRemixUpgradeModalStore.getState().open(getRemixInsufficientCreditsOpenOptions());
}
